export default {
  dateWithoutMs: value => value.indexOf('.') !== -1 ? value.slice(0, value.indexOf('.')) : value.slice(0, value.indexOf('+')),
  dateWithSeparatedTime: value => value.slice(0, value.indexOf('.')).replace('T', ' '),
};
